import React from 'react';
import { useTranslation } from 'react-i18next';
import { getPodBatchComposeConfig } from '@/pages/ipe/workbench/constants/podBatchComposeConfig';

const FLOW_TITLE_KEY = {
  flatLay: 'podFlat',
  model: 'podModel',
};

const STEP_LABEL_KEY = {
  印花素材: 'podStamp',
  设计模板: 'podTemplate',
  合成成品: 'podResult',
};

/**
 * POD 商品设计空态：流程示意 + 选模板入口（功能页 / 详情快捷弹窗共用）。
 */
export default function PodBatchDesignFlowIntro({
  selectButton = null,
  className = '',
  hintExtra = null,
}) {
  const { t } = useTranslation('workbench');
  const config = getPodBatchComposeConfig();
  const rootClass = ['pod-batch__intro', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      <div className="pod-batch__flow-groups" aria-label={t('studioChrome.podFlowAria')}>
        {config.workflowFlowSets.map((flowSet) => {
          const flowTitle = t(`studioChrome.${FLOW_TITLE_KEY[flowSet.id] || 'podFlat'}`);
          return (
          <section key={flowSet.id} className="pod-batch__flow-group">
            <h2 className="pod-batch__flow-group-title">{flowTitle}</h2>
            <div className="pod-batch__flow-showcase">
              {flowSet.steps.map((step, index) => (
                <React.Fragment key={`${flowSet.id}-${step.label}`}>
                  <div className="pod-batch__flow-step">
                    <div
                      className={`pod-batch__flow-frame${step.transparentBg ? ' pod-batch__flow-frame--checkerboard' : ''}`}
                    >
                      <img
                        src={step.image}
                        alt={`${flowTitle} - ${t(`studioChrome.${STEP_LABEL_KEY[step.label] || 'podStamp'}`)}`}
                        loading="lazy"
                        className={step.transparentBg ? 'pod-batch__flow-img--contain' : undefined}
                      />
                    </div>
                    <span className="pod-batch__flow-label">{t(`studioChrome.${STEP_LABEL_KEY[step.label] || 'podStamp'}`)}</span>
                  </div>
                  {index < flowSet.steps.length - 1 && (
                    <span className="pod-batch__flow-arrow" aria-hidden="true">→</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </section>
          );
        })}
      </div>
      <p className="pod-batch__flow-caption">{t('studioChrome.podCaption')}</p>
      <div className="pod-batch__intro-actions">
        <div className="img2img-studio__upload-actions">{selectButton}</div>
      </div>
      <div className="img2img-studio__upload-hint">
        <p>{t('studioChrome.podHint')}</p>
        {hintExtra}
      </div>
    </div>
  );
}
